import { FiSearch } from "react-icons/fi";
import Input from "@components/Input";

export function PayrollReviewFilters({
  searchVal,
  onSearchChange,
  payTypeFilter,
  onPayTypeChange,
  statusFilter,
  onStatusChange,
  checksStatusFilter,
  onChecksStatusChange,
  directDepositStatusFilter,
  onDirectDepositStatusChange,
  activeTab,
  paymentsSubTab,
  periodStart,
  onPeriodStartChange,
}: {
  searchVal: string;
  onSearchChange: (val: string) => void;
  payTypeFilter: string;
  onPayTypeChange: (val: string) => void;
  statusFilter: string;
  onStatusChange: (val: string) => void;
  checksStatusFilter: string;
  onChecksStatusChange: (val: string) => void;
  directDepositStatusFilter: string;
  onDirectDepositStatusChange: (val: string) => void;
  activeTab: number;
  paymentsSubTab: number;
  periodStart: string;
  onPeriodStartChange: (val: string) => void;
}) {
  return (
    <div className="tw-bg-white dark:tw-bg-[#0D1117] tw-rounded-lg tw-border tw-border-gray-200 dark:tw-border-gray-700 tw-p-2 tw-mb-2">
      <div className="tw-flex tw-flex-col md:tw-flex-row md:tw-items-center md:tw-justify-between tw-gap-2">
        <div className="tw-flex tw-flex-col tw-gap-1 md:tw-flex-row md:tw-items-center md:tw-gap-1 md:tw-flex-wrap">
          <div className="tw-w-full md:tw-w-96">
            <Input
              icon={FiSearch}
              containerStyle={{
                marginRight: 0,
                width: "100%",
                height: 28,
              }}
              id="payroll-review-search"
              type="text"
              name="search"
              placeholder="search"
              onChange={(e: any) => onSearchChange(e.target.value)}
              disabled={false}
              value={searchVal}
            />
          </div>
          {activeTab === 0 && (
            <div className="tw-flex tw-items-center tw-gap-1 tw-w-full md:tw-w-auto">
              <label className="tw-text-[12px] tw-text-gray-600 dark:tw-text-gray-300">
                Pay Type:
              </label>
              <select
                value={payTypeFilter}
                onChange={(e) => onPayTypeChange(e.target.value)}
                className="tw-border tw-rounded tw-px-1 tw-py-0.5 tw-text-[12px] tw-bg-white dark:tw-bg-[#111827]"
              >
                <option value="">All</option>
                <option value="Check">Check</option>
                <option value="Direct Deposit">Direct Deposit</option>
              </select>
            </div>
          )}
          {activeTab === 0 && (
            <div className="tw-flex tw-items-center tw-gap-1 tw-w-full md:tw-w-auto">
              <label className="tw-text-[12px] tw-text-gray-600 dark:tw-text-gray-300">
                Status:
              </label>
              <select
                value={statusFilter}
                onChange={(e) => onStatusChange(e.target.value)}
                className="tw-border tw-rounded tw-px-1 tw-py-0.5 tw-text-[12px] tw-bg-white dark:tw-bg-[#111827]"
              >
                <option value="">All</option>
                <option value="Review">Review</option>
                <option value="Finalized">Finalized</option>
                <option value="Zero Hours">Zero Hours</option>
              </select>
            </div>
          )}

          {activeTab === 1 && paymentsSubTab === 0 && (
            <div className="tw-flex tw-items-center tw-gap-1 tw-w-full md:tw-w-auto">
              <label className="tw-text-[12px] tw-text-gray-600 dark:tw-text-gray-300">
                Status:
              </label>
              <select
                value={checksStatusFilter}
                onChange={(e) => onChecksStatusChange(e.target.value)}
                className="tw-border tw-rounded tw-px-1 tw-py-0.5 tw-text-[12px] tw-bg-white dark:tw-bg-[#111827]"
              >
                <option value="">All</option>
                <option value="Pending">Pending</option>
                <option value="Check Issued">Check Issued</option>
                <option value="Check Cancelled">Check Cancelled</option>
              </select>
            </div>
          )}

          {activeTab === 1 && paymentsSubTab === 1 && (
            <div className="tw-flex tw-items-center tw-gap-1 tw-w-full md:tw-w-auto">
              <label className="tw-text-[12px] tw-text-gray-600 dark:tw-text-gray-300">
                Status:
              </label>
              <select
                value={directDepositStatusFilter}
                onChange={(e) => onDirectDepositStatusChange(e.target.value)}
                className="tw-border tw-rounded tw-px-1 tw-py-0.5 tw-text-[12px] tw-bg-white dark:tw-bg-[#111827]"
              >
                <option value="">All</option>
                <option value="Pending">Pending</option>
                <option value="Direct Generated">Direct Generated</option>
                <option value="Direct Deposit Canceled">
                  Direct Deposit Canceled
                </option>
              </select>
            </div>
          )}
        </div>

        <div className="tw-flex tw-items-center tw-gap-1">
          <label className="tw-text-[12px] tw-text-gray-600 dark:tw-text-gray-300">
            Pay Period:
          </label>
          <input
            type="date"
            value={periodStart}
            onChange={(e) => onPeriodStartChange(e.target.value)}
            className="tw-border tw-rounded tw-px-1 tw-py-0.5 tw-text-[12px] tw-bg-white dark:tw-bg-[#111827] tw-w-32"
          />
        </div>
      </div>
    </div>
  );
}
